import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconOrganization from './nav-icon-organization.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconOrganization {...validProps} />;
}
SvgComponent.iconName = 'navIconOrganization';

export const NavIconOrganizationIcon = svgIconWrapper(SvgComponent);
